const hotelChains = {
  name: 'Cadena |||| Cadenas',
  fields: {
    name: 'Nombre',
    hotelCount: 'Nº hoteles',
    website: 'Web',
    country: 'País sede',
    notes: 'Observaciones',
  },
  empty: 'No se encontraron cadenas',
  invite: 'Cree su primera cadena',
};

export default hotelChains;
